import { SwapPayload } from "./reducer";

export const selectCurrency = (value: SwapPayload) => {
  return {
    type: "SWAP",
    payload: value,
  };
};